const closedCaptionLabels = {
  en: 'English',
  es: 'Español',
};

export default closedCaptionLabels;
